/* eslint-disable angular/controller-name */

angular.
module("digiexam").
controller("GettingStartedGuideController", function GettingStartedGuideController(
	$location,

	dxLocalize,
	dxSession,
	DX_URLS,

	dxDialog
) {
	"use strict";

	var self = this;

	self.dxLocalize = dxLocalize;
	self.user = dxSession.getUser();

	self.numberOfSlides = 8;
	// The first slide is 1.
	self.currentSlide = 1;
	self.paginationSlides = [];
	// Exclude the first slide, because it was like that in the design from Vektor Grafik.
	for (var slideNumber = 2; slideNumber <= self.numberOfSlides; slideNumber++) {
		self.paginationSlides.push(slideNumber);
	}

	self.user.load();

	self.onLastSlide = function onLastSlide() {
		return self.currentSlide === self.numberOfSlides;
	};

	self.nextSlide = function nextSlide($event) {
		$event.stopPropagation();

		if (self.onLastSlide()) {
			$location.path(DX_URLS.get("examCreate"));
			dxDialog.closeMostRecent();
		} else {
			self.currentSlide++;
		}
	};

	self.goToSlide = function goToSlide($event, slide) {
		$event.stopPropagation();

		if (typeof slide === "number" && slide >= 1 && slide <= self.numberOfSlides) {
			self.currentSlide = slide;
		}
	};

	self.updateGettingStartedGuideSetting = function updateGettingStartedGuideSetting() {
		self.user.update();
	};
});
